import React from "react";
import { Link } from "react-router-dom";
import { Accordion } from "../../components/shared/accordion";
import { Icon } from "@iconify/react/dist/iconify.js";
import _ from "lodash";

import { PLATFORM_HELP_DATA } from "../data/platform-help-data";

/**
 * Componente que muestra las preguntas y respuestas correspondientes a la plataforma
 * @param {object} interfaceTexts - objeto con los textos de interfaz
 * @returns {JSX.Element} PlatformHelp
 */
export const PlatformHelp = ({ interfaceTexts }) => {

    const infoPlatform = [...PLATFORM_HELP_DATA];

    return (
        <>
            <Link to={'/ayuda'} className="secondary-button py-2 px-3">
                <Icon icon="material-symbols:arrow-back-rounded" width="24" height="24" />
                {interfaceTexts?.botones?.volver || 'volver'}
            </Link>

            <h2 className="my-4">{interfaceTexts?.platform?.titulo || 'plataforma'}</h2>

            <Accordion.Container>
                {
                    infoPlatform?.map((item) => {
                        return (
                            <Accordion.Item key={item?.id}>
                                <Accordion.ItemButton
                                    className={'acordeon px-3 py-2'}
                                    label={_.get(interfaceTexts, item?.textButton?.translationPath) || item?.textButton?.default}
                                />
                                <Accordion.Content className={'focusable-secondary opcionAcordeon relative'}>
                                    <div key={`video-${item?.id}`} className="w-100">
                                        <iframe
                                            src={_.get(interfaceTexts, item?.video?.translationPath) || item?.video?.default}
                                            title={_.get(interfaceTexts, item?.textButton?.translationPath) || item?.textButton?.default}
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; picture-in-picture; fullscreen" allowFullScreen
                                            className='focusable-secondary videoInstruccion'
                                        ></iframe>
                                    </div>
                                </Accordion.Content>
                            </Accordion.Item>
                        )
                    })
                }
            </Accordion.Container>
        </>
    )
}